import z from "zod";
import { Gender } from "@/openapi/generated";
import { isSelectableStudentGender } from "@/lib/utils/gender/student-gender";

export const studentGenderFormField = z
  .union([z.nativeEnum(Gender), z.literal("")])
  .refine((val) => isSelectableStudentGender(val), {
    message: "Gender is required",
  });
